import { MapActions, MapState } from "../store/types/map";
import { Model } from "../store/types/session";
import { useStoreActions, useStoreState } from "./store";

export const useSessionActions: MapActions<Model> = (mapActions) =>
  useStoreActions((actions) => mapActions(actions.session));
export const useSessionState: MapState<Model> = (mapState) =>
  useStoreState((state) => mapState(state.session));
